import React from "react";   
import HeaderComponent from "../../shared/components/HeaderComponent";
import FooterComponent from "../../shared/components/FooterComponent";
import { useLocation } from 'react-router-dom';
import Register from '../../shared/components/Register';
import SignIn from '../../shared/components/SignIn';
import ValidActive from '../../shared/components/ValidActive';
import LoginConfirmation from '../../shared/components/LoginConfirmation';
import {useTranslation} from "react-i18next"
import {Helmet} from "react-helmet-async";

import lateralImg from './../../../assets/img/lateral.png'

import "./Login.scss";



// Login page
// Handles login routes
// Uses header and footer component
export default function Login() { 

  const location = useLocation(); 
  const { t } = useTranslation();

  const showLocation = () => {
    if (location.pathname.includes('Register')) {
      return <Register/>;
    } else if (location.pathname.includes('SuccessConfirm')) {
      return <LoginConfirmation/>;
    } else if (location.pathname.includes('validactive')) {
      return <ValidActive/>;
    } else {
      return <SignIn/>
    }
  }
 
  return (
    <div className="login fixed w-screen h-screen">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t('SEO.LOGIN.TITLE')}</title>
        <meta name="description" content={t('SEO.LOGIN.DESCRIPTION')} />
      </Helmet>
      <HeaderComponent loginPage={true}></HeaderComponent> 
      <div className="login-container"> 
        <div>
          <img src={lateralImg} alt="login" />
        </div>
        <div className={"content"}>
           { showLocation() }
        </div>
      </div>
      <FooterComponent loginPage={true}></FooterComponent>
    </div>
  );
} 